<div class="form-footer">
  <button
    (click)="onCancelClick()"
    data-cy="form-footer-cancel"
    matButton="outlined"
    type="button"
    i18n
  >
    Cancel
  </button>
  <div class="form-footer-right">
    @if (stepper && stepper?.selectedIndex > 0) {
      <button
        (click)="goToPrevious()"
        data-cy="form-footer-previous"
        matButton="outlined"
        type="button"
        i18n
      >
        Previous
      </button>
    }

    @if (stepper && stepper?.selectedIndex < stepper?.steps.length - 1) {
      <button (click)="goToNext()" type="button" data-cy="form-footer-next" matButton="filled" i18n>
        Next
      </button>
    } @else {
      @if (!isReadonly) {
        <button
          [disabled]="submitting"
          color="primary"
          data-cy="form-footer-submit"
          matButton="filled"
          type="submit"
        >
          @if (submitButtonText) {
            <ng-container>{{ submitButtonText }}</ng-container>
          } @else {
            @if (isEditMode) {
              <ng-container i18n>Update</ng-container>
            } @else {
              <ng-container i18n>Create</ng-container>
            }
          }
        </button>
      }
    }
  </div>
</div>
